export const PAGE_TITLE = "Donations";
export const PAGE_SINGLE_TITLE = "Donation";
export const LINK_URL = "donations";
export const SEARCH_TERMS = ["amount", "name", "phone", "volunteer"];
export const inputFields = {
  name: {
    type: "string",
    required: true,
    title: "Name",
  },
  email: {
    type: "string",
    required: true,
    title: "Email",
  },
  phone: {
    type: "string",
    required: true,
    title: "Phone",
  },
  pan: {
    type: "string",
    required: false,
    title: "PAN",
  },

  amount: {
    type: "string",
    required: true,
    title: "Amount",
    inputType: "number",
  },

  address: {
    type: "string",
    required: false,
    title: "Address",
  },
  pincode: {
    type: "string",
    required: false,
    title: "Pincode",
  },

  transaction_id: {
    type: "string",
    required: false,
    title: "Transaction ID",
  },
  project: {
    type: "string",
    required: false,
    title: "Page",
  },
  referrer: {
    type: "string",
    required: false,
    title: "Referrer",
  },
};
export const initialValues = {
  name: "",
  email: "",
  phone: "",
  pan: "",
  amount: "",
  address: "",
  transaction_id: "",
  referrer: "",
};

export const view_all_table = [
  { name: "Amount", value: "amount" },
  { name: "Donor Name", value: "name" },
  { name: "Phone", value: "phone" },
  { name: "Email", value: "email" },
  { name: "Trans id", value: "transaction_id" },
  { name: "Page", value: "project" },
  { name: "Referrer", value: "referrer" },
];
